<template>
    <div>
        <div
            v-for="(groupName) in groupNamesSorted"
            :key="groupName"
            class="mb-3"
        >
            <div
                class="h4 group-name"
                @click="toggleGroup(groupName)"
            >
                <DIcon :name="collapseGroups[groupName] ? 'arrow-up' : 'arrow-down'" /> {{ groupName }}
            </div>
            <DTable
                v-if="collapseGroups[groupName] === true && groupName !== __('tools.emails.placeholder_groups.help_on_template_logic')"
                :items="placeholders[groupOriginalNameTranslatedNameMap[groupName]]"
                :fields="fields"
            >
                <template #placeholder="{ item }">
                    <td
                        class="cursor-pointer"
                        @click="copyToClipboard(item.placeholder)"
                    >
                        <span v-c-tooltip="__('messages.click_to_copy')">{{ item.placeholder }}</span>
                    </td>
                </template>
            </DTable>
            <HelpTemplateDocs
                v-if="collapseGroups[groupName] === true && groupName === __('tools.emails.placeholder_groups.help_on_template_logic')"
                :documentations="documentation"
            />
        </div>
    </div>
</template>

<script>
import HelpTemplateDocs from '~@/Components/Common/Settings/HelpTemplateDocs.vue'
import emailDocs from '~@/Mixins/emailDocs'

export default {
    name: 'EmailPlaceholders',
    components: { HelpTemplateDocs },
    mixins: [emailDocs],
    props: {
        placeholders: {
            type: Object,
            default: () => { return {} }
        }
    },
    data () {
        return {
            fields: [
                { key: 'placeholder', label: this.__('settings.invoice_pdf_settings.available_placeholders') },
                { key: 'description', label: this.__('settings.invoice_pdf_settings.description') }
            ],
            groupNamesSorted: [],
            collapseGroups: {},
            groupOriginalNameTranslatedNameMap: {}
        }
    },
    computed: {
        documentation () {
            return emailDocs
        }
    },
    created () {
        const collapseGroups = {}
        let groupNamesSorted = []
        const groupOriginalNameTranslatedNameMap = {}

        for (const groupName in this.placeholders) {
            const translatedGroupName = this.__(`tools.emails.placeholder_groups.${groupName}`)

            collapseGroups[groupName] = false
            groupNamesSorted.push(translatedGroupName)
            groupOriginalNameTranslatedNameMap[translatedGroupName] = groupName
        }

        groupNamesSorted = groupNamesSorted.sort()

        // Add help template help logic for each page
        const translatedGroupName = this.__('tools.emails.placeholder_groups.help_on_template_logic')
        collapseGroups.help_on_template_logic = false
        groupNamesSorted.push(translatedGroupName)
        groupOriginalNameTranslatedNameMap[translatedGroupName] = 'help_on_template_logic'

        this.collapseGroups = collapseGroups
        this.groupNamesSorted = groupNamesSorted
        this.groupOriginalNameTranslatedNameMap = groupOriginalNameTranslatedNameMap
    },
    methods: {
        async toggleGroup (groupName) {
            const collapseGroups = { ...this.collapseGroups }
            collapseGroups[groupName] = !collapseGroups[groupName]

            this.collapseGroups = collapseGroups
        },
        copyToClipboard (contents) {
            navigator.clipboard.writeText(contents)
        }
    }
}
</script>

<style scoped>
.group-name {
    cursor: pointer;
}

.cursor-pointer {
    cursor: pointer;
}
</style>
